import { Box, Skeleton } from '@mui/material';
import React from 'react';

const SidebarSkeleton = () => {
  return (
    <div className="p-3">
      {Array.from({ length: 12 }).map((_, idx) => (
        <Box key={idx} display="flex" alignItems="center" className="my-2" height={36}>
          <Skeleton variant="circular" width={20} height={20} className="mx-2" />
          <Skeleton variant="rectangular" width={'70%'} height={16} />
        </Box>
      ))}
    </div>
  );
};

export default SidebarSkeleton;
